import React, { useId, useRef } from 'react';
import { Box, Button, InputLabel, TextField } from '@mui/material';
import * as styles from './FileInput.scss';

const FileInput = (props) => {
  const {
    accept,
    buttonLabel = 'Browse',
    disabled,
    error,
    errorText,
    helperText,
    id,
    label,
    loading,
    onChange,
    placeholder = 'Choose a file...',
    required,
    size = 'small',
    slotProps,
    sx,
    value,
  } = props;

  const fileInput = useRef(null);
  const generatedId = useId();

  const handleButtonClick = () => fileInput.current.click();

  return (
    <Box className={styles.container} sx={sx}>
      {label && <InputLabel htmlFor={id ?? generatedId} shrink={false} error={error} required={required}>{label}</InputLabel>}
      <TextField
        id={id ?? generatedId}
        value={value ?? ''}
        disabled
        error={error}
        fullWidth
        helperText={errorText ?? helperText}
        required={required}
        size={size}
        slotProps={{
          ...slotProps?.textField,
          input: {
            ...slotProps?.textField?.input,
            placeholder,
            endAdornment: (
              <Button
                variant="contained"
                size={size}
                onClick={handleButtonClick}
                disabled={disabled}
                loading={loading}
              >
                {buttonLabel}
              </Button>
            ),
          },
        }}
      />
      <input type="file" ref={fileInput} onChange={onChange} style={{ display: 'none' }} disabled={disabled} accept={accept} />
    </Box>
  );
};

export default FileInput;
